import { useEffect, useState } from "react";
import { Col, Image, Row, Container } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, url } from "../axios/api";
import moment from 'moment';
import 'moment/locale/pt';
import { useParams, useNavigate } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaArrowLeft } from "react-icons/fa";

const DetalhesNoticia = () => {
    const [noticia, setNoticia] = useState({});
    const { id } = useParams();
    const navigate = useNavigate();

    const getNoticia = async () => {
        try {
            const res = await api.get(`/Noticia.php?action=read&&id=${id}`);
            setNoticia(res.data.data);
        } catch (error) {
            console.error("Erro ao carregar a notícia:", error);
        }
    }

    useEffect(() => {
        getNoticia();
        moment.locale('pt');
        window.scrollTo(0, 0); // Garante que a página comece no topo
    }, [id]);

    return (
        <>
            <Navbar />

            <main style={{ backgroundColor: "#fdfcf9", minHeight: "80vh" }}>
                {/* --- CABEÇALHO DO ARTIGO --- */}
                <header className="py-5" style={{ backgroundColor: "#2c2219", color: "#f4f1ea" }}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={10} xl={8}>
                                <button 
                                    onClick={() => navigate(-1)}
                                    className="btn btn-link p-0 mb-4 text-decoration-none d-flex align-items-center"
                                    style={{ color: "#c5a47e", fontSize: "0.9rem" }}
                                >
                                    <FaArrowLeft className="me-2" /> VOLTAR PARA PUBLICAÇÕES
                                </button>
                                
                                <h1 className="display-5 fw-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                                    {noticia.titulo}
                                </h1>

                                <div className="d-flex flex-wrap gap-4 opacity-75 small text-uppercase fw-bold" style={{ letterSpacing: "1px" }}>
                                    <span>
                                        <FaUser className="me-2" style={{ color: "#c5a47e" }} />
                                        {noticia.autor_nome || "Paul Rodney & Associados"}
                                    </span>
                                    <span>
                                        <FaCalendarAlt className="me-2" style={{ color: "#c5a47e" }} />
                                        {moment(noticia.createdAt).format("DD [de] MMMM, YYYY")}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </header>

                {/* --- CONTEÚDO DO ARTIGO --- */}
                <Container className="py-5">
                    <Row className="justify-content-center">
                        <Col lg={10} xl={8}>
                            {/* Imagem de Destaque */}
                            <div className="mb-5 shadow-sm border p-2 bg-white">
                                <Image
                                    src={url + "/uploads/" + noticia.foto}
                                    className="w-100 object-fit-cover"
                                    style={{ maxHeight: "500px" }}
                                />
                            </div>

                            {/* Corpo do Texto */}
                            <div
                                className="article-body"
                                style={{ 
                                    fontSize: "1.15rem", 
                                    lineHeight: "1.9", 
                                    color: "#333",
                                    textAlign: "justify"
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: noticia.descricao?.replace(/\n/g, "<br/>") || "",
                                }}
                            ></div>

                            <hr className="my-5" style={{ opacity: "0.1" }} />
                            
                            {/* Rodapé do Artigo */}
                            <div className="p-4 border-start border-4" style={{ borderColor: "#c5a47e", backgroundColor: "#f4f1ea" }}>
                                <p className="mb-0 small text-muted">
                                    Este artigo tem caráter meramente informativo e não substitui a consulta jurídica especializada. 
                                    Para aconselhamento específico, entre em contacto com os nossos especialistas.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </main>

            <Footer />

            <style>{`
                .article-body {
                    font-family: 'Inter', sans-serif;
                }
                .article-body b, .article-body strong {
                    color: #2c2219;
                }
                /* Estilização básica para possíveis tags HTML vindas do banco */
                .article-body h2, .article-body h3 {
                    font-family: 'Playfair Display', serif;
                    margin-top: 2rem;
                    color: #2c2219;
                }
            `}</style>
        </>
    );
};

export default DetalhesNoticia;